class Wiki {
  constructor(firebaseDatabase) {
    this.pages = firebaseDatabase.ref(Wiki.PAGES_REF);
  }

  getRef_(name) {
    return this.pages.child(name);
  }

  /** 
   * Returns a firebase.Promise that resolves to a map of values for the page. 
   */
  get(name) {
    return this.getRef_(name).once("value");
  }

  /** 
   * Returns a firebase.Promise that resolves when write to server is complete.
   */
  setContent(name, content) {
    return this.getRef_(name).child(Wiki.PageField.CONTENT).set(content);
  }
}

Wiki.PAGES_REF = "wiki/pages";

Wiki.PageField = {
  CONTENT: "content"
};

export default Wiki;



// WEBPACK FOOTER //
// ./src/services/wiki.js